<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-layout row>
        <v-flex md12>
          <v-card-title stlyle="width:100%" class="primary">
            <h3 style="font-size: 18px; color: #FFF; font-weight: 500">
              {{ edicao ? "Editar" : "Adicionar" }} Classificação
            </h3>
          </v-card-title>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-form v-model="validaFormClassificacao" ref="formClassificacao">
        <v-layout row wrap>
          <v-flex class="px-2" md6>
            <v-text-field
              v-model="classificacaoCotacaoModel.nome"
              label="Nome"
              :rules="regras.notNull"
            ></v-text-field>
          </v-flex>
          <v-flex class=" px-2 custom-classificacao" md6>
            <p class="mb-0" style="text-align: left; width: 100%">
              Classificação
            </p>
            <star-rating
              v-model="classificacaoCotacaoModel.classificacao"
              :star-size="28"
              v-bind:increment="0.5"
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex class="px-2" md6>
            <v-select
              v-model="classificacaoCotacaoModel.listaCategoriaTarifaria"
              :items="listaCategorias"
              item-value="id"
              item-text="titulo"
              :rules="regras.multiplesRule"
              label="Categoria Tarifária"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.titulo }} </span>
                <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
                <span v-if="index === 2">
                  (+{{
                    classificacaoCotacaoModel.listaCategoriaTarifaria.length - 2
                  }}
                  outros)
                </span>
                <span></span>
              </template>
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="selectionarTodosItensTarifaria">
                  <v-list-tile-action>
                    <v-icon
                      style="color: #00456e"
                      class="material-icons-outlined"
                    >
                      {{ iconeSelecionarTodosTarifaria }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Selecionar todos</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-flex>
          <v-flex class="px-2" md6>
            <v-select
              v-model="classificacaoCotacaoModel.listaCoberturas"
              :items="listaCoberturas"
              item-value="id"
              item-text="titulo"
              :rules="regras.multiplesRule"
              label="Tipo Cobertura"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.titulo }} </span>
                <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
                <span v-if="index === 2">
                  (+{{
                    classificacaoCotacaoModel.listaCoberturas.length - 2
                  }}
                  outros)
                </span>
                <span></span>
              </template>
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="selectionarTodosItensCobertura">
                  <v-list-tile-action>
                    <v-icon
                      style="color: #00456e"
                      class="material-icons-outlined"
                    >
                      {{ iconeSelecionarTodosCobertura }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Selecionar todos</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 class="px-2">
            <v-select
              v-model="classificacaoCotacaoModel.listaCargaTransportada"
              :items="listaCargas"
              :rules="regras.multiplesRule"
              item-value="id"
              item-text="titulo"
              label="Carga Transportada"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.titulo }} </span>

                <span v-if="index === 1">
                  (+{{
                    classificacaoCotacaoModel.listaCargaTransportada.length - 1
                  }}
                  outros)
                </span>
                <span></span>
              </template>
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="selectionarTodosItensCarga">
                  <v-list-tile-action>
                    <v-icon
                      style="color: #00456e"
                      class="material-icons-outlined"
                    >
                      {{ iconeSelecionarTodosCarga }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Selecionar todos</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-flex>
          <v-flex md6 class="px-2">
            <v-select
              v-model="classificacaoCotacaoModel.idInicioVigencia"
              :items="listaIniciaVigencia"
              item-value="id"
              item-text="titulo"
              label="Inicia Vigência"
              :rules="regras.notNull"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 class="px-2">
            <v-select
              v-model="classificacaoCotacaoModel.listaRegiao"
              :items="listaRegiao"
              item-value="id"
              item-text="sigla"
              label="Região"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.sigla }}; &nbsp;</span>
                <span v-if="index === 1">{{ item.sigla }} </span>
                <span v-if="index === 2">
                  (+{{
                    classificacaoCotacaoModel.listaRegiao.length - 2
                  }}
                  outros)
                </span>
                <span></span>
              </template>
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="selectionarTodosItensRegiao">
                  <v-list-tile-action>
                    <v-icon
                      style="color: #00456e"
                      class="material-icons-outlined"
                    >
                      {{ iconeSelecionarTodosRegiao }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Selecionar todos</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-flex>
          <v-flex md6 class="px-2">
            <v-select
              v-model="classificacaoCotacaoModel.listaCorretorResponsavel"
              :items="listaCorretorResponsavel"
              item-value="id"
              item-text="nome"
              label="Corretor parceiro"
              multiple
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.nome }}; &nbsp;</span>
                <span v-if="index === 1">{{ item.nome }} </span>
                <span v-if="index === 2">
                  (+{{
                    classificacaoCotacaoModel.listaCorretorResponsavel.length -
                      2
                  }}
                  outros)
                </span>
                <span></span>
              </template>
              <template v-slot:prepend-item>
                <v-list-tile ripple @click="selectionarTodosItensCorretor">
                  <v-list-tile-action>
                    <v-icon
                      style="color: #00456e"
                      class="material-icons-outlined"
                    >
                      {{ iconeSelecionarTodosCorretor }}
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Selecionar todos</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6> 
            <p class="ma-0 px-2" style="color:rgb(80, 76, 76)">Faixa prêmio total</p>
            <v-layout row >
              <v-flex class="px-2" md6>
                <v-text-field
                  v-model="valorInicialPremio"
                  ref="valorInicialPremio"
                  v-money="maskComputed.maskMoney"
                  label="De"
                  :rules="[regras.notNull, validateValorFaixaPremioDe]"
                ></v-text-field>
              </v-flex>
              <v-flex class="px-2" md6>
                <v-text-field
                  ref="valorFinalPremio"
                  v-money="maskComputed.maskMoney"
                  v-model="valorFinalPremio"
                  label="Até"
                  :rules="[regras.notNull, validateValorFaixaPremioAte]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md6>
            <p class="ma-0 px-2" style="color:rgb(80, 76, 76)">Quantidade de itens</p>
            <v-layout row >
              <v-flex class="px-2" md6>
                <v-text-field
                  v-model.number="classificacaoCotacaoModel.quantidadeItensDe"
                  type="number"
                  ref="valorInicialItem"
                  label="De"
                  :rules="classificacaoCotacaoModel.quantidadeItensDe !== null ? [regras.notNull, validateQuantidadeItensDe] : []"
                ></v-text-field>
              </v-flex>
              <v-flex class="px-2" md6>
                <v-text-field
                  ref="valorFinalItem"
                  v-model.number="classificacaoCotacaoModel.quantidadeItensAte"
                  type="number"
                  label="Até"
                  :rules="classificacaoCotacaoModel.quantidadeItensAte !== null ? [regras.notNull, , validateQuantidadeItensAte] : []"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex class="px-2" md3>
            <v-select
              label="Status"
              v-model="classificacaoCotacaoModel.ativo"
              :rules="regras.notNull"
              :items="opcoesAtivo"
              item-value="valor"
              item-text="titulo"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-flex class="px-2 custom-actions mb-3" md12>
        <v-btn @click="fecharModalClassificacao" color="primary" flat outline>
          Cancelar
        </v-btn>
        <v-btn
          v-show="!edicao"
          :disabled="!habilitaSalvar"
          @click="salvarClassificacaoCotacao"
          color="primary"
        >
          Salvar
        </v-btn>
        <v-btn
          v-show="edicao"
          :disabled="!habilitaSalvar"
          @click="salvarEdicaoClassificacao"
          color="primary"
        >
          Atualizar
        </v-btn>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import { VMoney } from "v-money";
import mask from "@/helpers/mask";
import CustomFormat from "@/helpers/custom-format";

export default {
  name: "ModalClassificacaoCotacao",
  directives: {
    money: VMoney
  },
  components: {
    StarRating
  },
  props: {
    listaCoberturas: {
      type: Array,
      required: false
    },
    listaCategorias: {
      type: Array,
      required: false
    },
    listaCargas: {
      type: Array,
      required: false
    },
    listaRegiao: {
      type: Array,
      required: false
    },
    listaCorretorResponsavel: {
      type: Array,
      required: false
    },
    listaIniciaVigencia: {
      type: Array,
      required: false
    },
    classificacaoRetornada: {
      required: false
    }
  },
  data() {
    return {
      validaFormClassificacao: true,
      valorInicialPremio: null, 
      valorFinalPremio: null,
      opcoesAtivo: [
        {
          valor: true,
          titulo: "Ativo"
        },
        {
          valor: false,
          titulo: "Inativo"
        }
      ],
      regras: {
        notNull: [v => v != null || "Você não pode deixar este campo em branco"],
        multiplesRule: [
          v => v.length > 0 || "Você não pode deixar este campo em branco"
        ]
      },
      listaCategoriaTarifaria: [],
      edicao: false,
      itemNaoEditado: null,
      classificacaoCotacaoModel: {
        id: null,
        nome: null,
        classificacao: null,
        listaCategoriaTarifaria: [],
        listaCoberturas: [],
        listaRegiao: [],
        listaCorretorResponsavel: [],
        listaCargaTransportada: [],
        idUsuarioCriacao: null,
        idInicioVigencia: null,
        dataHoraCriacao: null,
        nomeUsuarioCriacao: null,
        valorFaixaPremioDe: null,
        valorFaixaPremioAte: null,
        quantidadeItensDe: null,
        quantidadeItensAte: null,
        ativo: true, 
      }
    };
  },
  computed: {
    maskComputed() {
      return mask;
    },
    habilitaSalvar() {
      var editado = false;
      if (this.edicao) {
        var stringItemAux = JSON.stringify(this.classificacaoCotacaoModel);
        editado = this.itemNaoEditado === stringItemAux;
      }
      return (
        !editado &&
        this.validaFormClassificacao &&
        this.classificacaoCotacaoModel.classificacao > 0
      );
    },
    igualUmItemTarifaria() {
      return (
        this.classificacaoCotacaoModel.listaCategoriaTarifaria.length > 0 &&
        !this.igualTodosItensTarifaria
      );
    },
    iconeSelecionarTodosTarifaria() {
      if (this.igualTodosItensTarifaria) return "check_box";
      if (this.igualUmItemTarifaria) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualTodosItensTarifaria() {
      return (
        this.classificacaoCotacaoModel.listaCategoriaTarifaria.length ===
        this.listaCategorias.length
      );
    },
    igualUmItemCobertura() {
      return (
        this.classificacaoCotacaoModel.listaCoberturas.length > 0 &&
        !this.igualTodosItensCobertura
      );
    },
    iconeSelecionarTodosCobertura() {
      if (this.igualTodosItensCobertura) return "check_box";
      if (this.igualUmItemCobertura) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualTodosItensCobertura() {
      return (
        this.classificacaoCotacaoModel.listaCoberturas.length ===
        this.listaCoberturas.length
      );
    },
    igualUmItemCarga() {
      return (
        this.classificacaoCotacaoModel.listaCargaTransportada.length > 0 &&
        !this.igualTodosItensCarga
      );
    },
    iconeSelecionarTodosCarga() {
      if (this.igualTodosItensCarga) return "check_box";
      if (this.igualUmItemCarga) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualTodosItensCarga() {
      return (
        this.classificacaoCotacaoModel.listaCargaTransportada.length ===
        this.listaCargas.length
      );
    },
    igualUmItemRegiao() {
      return (
        this.classificacaoCotacaoModel.listaRegiao.length > 0 &&
        !this.igualTodosItensRegiao
      );
    },
    iconeSelecionarTodosRegiao() {
      if (this.igualTodosItensRegiao) return "check_box";
      if (this.igualUmItemRegiao) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualTodosItensRegiao() {
      return (
        this.classificacaoCotacaoModel.listaRegiao.length ===
        this.listaRegiao.length
      );
    },
    igualUmItemCorrretor() {
      return (
        this.classificacaoCotacaoModel.listaCorretorResponsavel.length > 0 &&
        !this.igualTodosItensCorretor
      );
    },
    iconeSelecionarTodosCorretor() {
      if (this.igualTodosItensCorretor) return "check_box";
      if (this.igualUmItemCorrretor) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualTodosItensCorretor() {
      return  this.classificacaoCotacaoModel.listaCorretorResponsavel.length === this.listaCorretorResponsavel.length;
    },
    validateValorFaixaPremioDe() {
    return this.classificacaoCotacaoModel.valorFaixaPremioDe <= this.classificacaoCotacaoModel.valorFaixaPremioAte || 'O valor inicial não pode ser maior que final.';
    },
    validateValorFaixaPremioAte() {
    return this.classificacaoCotacaoModel.valorFaixaPremioAte >= this.classificacaoCotacaoModel.valorFaixaPremioDe || 'O valor final  não pode ser menor que inicial.';
    },
    validateQuantidadeItensDe() {
    return this.classificacaoCotacaoModel.quantidadeItensDe <= this.classificacaoCotacaoModel.quantidadeItensAte || 'O valor inicial não pode ser maior que final.';
    },
    validateQuantidadeItensAte() {
    return this.classificacaoCotacaoModel.quantidadeItensAte >= this.classificacaoCotacaoModel.quantidadeItensDe || 'O valor final  não pode ser menor que inicial.';
    },
	},
  watch: {
    valorInicialPremio(val) {
      if (val != null && val != undefined && val != "") {
        this.classificacaoCotacaoModel.valorFaixaPremioDe = CustomFormat.removeMoneyFormat(
          val
        );
      }
    },
    valorFinalPremio(val) {
      if (val != null && val != undefined && val != "") {
        this.classificacaoCotacaoModel.valorFaixaPremioAte = CustomFormat.removeMoneyFormat(
          val
        );
      }
    },
    classificacaoRetornada(val) {
      if (val != null) {
        this.edicao = true;
        this.classificacaoCotacaoModel = {...val};
        this.itemNaoEditado = JSON.stringify({...val});
        this.$refs.valorInicialPremio.$el.getElementsByTagName('input')[0].value = val.valorFaixaPremioDe.toFixed(2)
        this.$refs.valorFinalPremio.$el.getElementsByTagName('input')[0].value = val.valorFaixaPremioAte.toFixed(2)
        this.$refs.valorInicialItem.$el.getElementsByTagName('input')[0].value = val.quantidadeItensDe
        this.$refs.valorFinalItem.$el.getElementsByTagName('input')[0].value = val.quantidadeItensAte
        this.classificacaoCotacaoModel = { ...val };
        this.itemNaoEditado = JSON.stringify({ ...val });
        this.$refs.valorInicialPremio.$el.getElementsByTagName(
          "input"
        )[0].value = val.valorFaixaPremioDe.toFixed(2);
        this.$refs.valorFinalPremio.$el.getElementsByTagName(
          "input"
        )[0].value = val.valorFaixaPremioAte.toFixed(2);
      }
    }
  },
  methods: {
    selectionarTodosItensCorretor() {
      this.$nextTick(() => {
        if (this.igualTodosItensCorretor) {
          this.classificacaoCotacaoModel.listaCorretorResponsavel = [];
        } else {
          const listagemItens = this.listaCorretorResponsavel.slice();
          this.classificacaoCotacaoModel.listaCorretorResponsavel = [];
          for (var listagemIten of listagemItens) {
            this.classificacaoCotacaoModel.listaCorretorResponsavel.push(
              listagemIten.id
            );
          }
        }
      });
    },
    selectionarTodosItensRegiao() {
      this.$nextTick(() => {
        if (this.igualTodosItensRegiao) {
          this.classificacaoCotacaoModel.listaRegiao = [];
        } else {
          const listagemItens = this.listaRegiao.slice();
          this.classificacaoCotacaoModel.listaRegiao = [];
          for (var listagemIten of listagemItens) {
            this.classificacaoCotacaoModel.listaRegiao.push(listagemIten.id);
          }
        }
      });
    },
    limparClassificacao() {
      this.classificacaoCotacaoModel.classificacao = 0;
      this.$refs.formClassificacao.reset();
      this.$refs.formClassificacao.resetValidation();
      this.$refs.valorInicialPremio.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.valorFinalPremio.$el.getElementsByTagName('input')[0].value = 0;
      this.classificacaoCotacaoModel.quantidadeItensDe = null;
      this.classificacaoCotacaoModel.quantidadeItensAte = null;

      this.edicao = false;
    },
    salvarEdicaoClassificacao() {
      this.$emit("comecarLoading");
      const objetoClassificacao = { ...this.classificacaoCotacaoModel };
      objetoClassificacao.idUsuarioCriacao = usuarioHelper.USUARIO_LOGADO().idUsuario;
      objetoClassificacao.nomeUsuarioCriacao = usuarioHelper.USUARIO_LOGADO().nome;
      axios
        .post(
          `${process.env.URL_COTACAOMS}/v1/editarClassificacao`,
          objetoClassificacao,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(res => {
          return res.data;
        })
        .then(data => {
          this.$emit("classificacaoSalva");
        })
        .catch(err => {
          this.$emit("erroSalvarClassificacao");
          this.$emit("fecharLoading");
          this.$emit("fecharModal");
        })
        .finally(() => {
          this.limparClassificacao();
          this.$emit("fecharLoading");
          this.$emit("fecharModal");
        });
    },
    salvarClassificacaoCotacao() {
      this.$emit("comecarLoading");
      const objetoClassificacao = { ...this.classificacaoCotacaoModel };
      objetoClassificacao.idUsuarioCriacao = usuarioHelper.USUARIO_LOGADO().idUsuario;
      objetoClassificacao.nomeUsuarioCriacao = usuarioHelper.USUARIO_LOGADO().nome;
      axios
        .post(
          `${process.env.URL_COTACAOMS}/v1/salvarClassificacaoCotacao`,
          objetoClassificacao,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(res => {
          return res.data;
        })
        .then(data => {
          this.$emit("classificacaoSalva");
        })
        .catch(err => {
          this.$emit("erroSalvarClassificacao");
          this.$emit("fecharLoading");
          this.$emit("fecharModal");
        })
        .finally(() => {
          this.limparClassificacao();
          this.$emit("fecharLoading");
          this.$emit("fecharModal");
        });
    },
    fecharModalClassificacao() {
      this.limparClassificacao();
      this.$emit("fecharModal");
    },
    selectionarTodosItensCobertura() {
      this.$nextTick(() => {
        if (this.igualTodosItensCobertura) {
          this.classificacaoCotacaoModel.listaCoberturas = [];
        } else {
          const listagemItens = this.listaCoberturas.slice();
          this.classificacaoCotacaoModel.listaCoberturas = [];
          for (var listagemIten of listagemItens) {
            this.classificacaoCotacaoModel.listaCoberturas.push(
              listagemIten.id
            );
          }
        }
      });
    },
    selectionarTodosItensTarifaria() {
      this.$nextTick(() => {
        if (this.igualTodosItensTarifaria) {
          this.classificacaoCotacaoModel.listaCategoriaTarifaria = [];
        } else {
          const listagemItens = this.listaCategorias.slice();
          this.classificacaoCotacaoModel.listaCategoriaTarifaria = [];
          for (var listagemIten of listagemItens) {
            this.classificacaoCotacaoModel.listaCategoriaTarifaria.push(
              listagemIten.id
            );
          }
        }
      });
    },
    selectionarTodosItensCarga() {
      this.$nextTick(() => {
        if (this.igualTodosItensCarga) {
          this.classificacaoCotacaoModel.listaCargaTransportada = [];
        } else {
          const listagemItens = this.listaCargas.slice();
          this.classificacaoCotacaoModel.listaCargaTransportada = [];
          for (var listagemIten of listagemItens) {
            this.classificacaoCotacaoModel.listaCargaTransportada.push(
              listagemIten.id
            );
          }
        }
      });
    }, 
    },
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    }
};
</script>
<style>
.custom-classificacao {
  display: flex !important;
  align-items: center !important;
  flex-direction: column;
}
.vue-star-rating {
  width: 100%;
  justify-content: flex-start !important;
}
.vue-star-rating-rating-text {
  width: 20px;
}
.custom-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classificacao-cotacoes/ModalClassificacaoCotacao.vue